import hexOpacity from 'hex-opacity';
import _ from 'lodash';
import React from 'react';
import SmartphoneOutlinedIcon from '@material-ui/icons/SmartphoneOutlined';
import DesktopWindowsOutlinedIcon from '@material-ui/icons/DesktopWindowsOutlined';
import FlareOutlinedIcon from '@material-ui/icons/FlareOutlined';
import Brightness2OutlinedIcon from '@material-ui/icons/Brightness2Outlined';
import { changeDesignWebMobile } from '../../apis/firebase';
import { ERROR_CHANGE_DESIGN, LIST_DESIGN_TYPE, SUCCESS_UPDATE_TEXT } from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { showNotification } from '../../components/Notification/Notification.view';
export const handleChangeComplete = (color, setnewSecondaryColor, setBackground) => {
  const { hex, rgb } = color;
  const newSecondaryColor = hexOpacity.create(hex, rgb.a);
  setnewSecondaryColor(newSecondaryColor);
  setBackground(newSecondaryColor.rgb);
};
export const initStates = async (darkTheme, descriptionText, secondaryColor, descriptionAddress, setStateObj, setnewSecondaryColor) => {
  setnewSecondaryColor(secondaryColor)
  setStateObj({
    descriptionText: descriptionText || descriptionAddress,
    isLoading: false,
    selectedMode: darkTheme ? 0 : 1
  });
};

export const handleChange = async (event, setStateObj) => {
  setStateObj({ [event.target.id]: event.target.checked });
};
export const getBottomNavigationData = (data, classes) => {
  const newData = [];
  _.map(data, e => {
    newData.push({
      label: e,
      icon:
        e === LIST_DESIGN_TYPE[0] ? (
          <DesktopWindowsOutlinedIcon className={classes.iconSize} />
        ) : (
          <SmartphoneOutlinedIcon className={classes.iconSize} />
        )
    });
  });
  return newData;
};
export const changeDesign = async (openErrorModal, descriptionText, newSecondaryColor, selectedMode, random, setStateObj, darkTheme, descriptionAddress, setnewSecondaryColor) => {
  const theme = selectedMode === 0 ? 'dark' : 'clear';
  try {
    setStateObj({
      isLoading: true
    });
    await changeDesignWebMobile(descriptionText, theme, newSecondaryColor);
    showNotification(
      'light',
      'ltr',
      'primary',
      SUCCESS_UPDATE_TEXT,
      `Les paramétres de design général ont bien été modifiés.`
    );
    initStates(darkTheme, descriptionText, newSecondaryColor, descriptionAddress, setStateObj, setnewSecondaryColor);
    setStateObj({
      random: random + 1
    });
  } catch (e) {
    sendCloudWatchAlert(`Error update web site ${e}`);
    openErrorModal(ERROR_CHANGE_DESIGN);
  }
  setStateObj({
    isLoading: false
  });
};
export const changeSwitchValue = async (event, newValue, setStateObj) => {
  await setStateObj({
    selected: newValue
  });
};
export const changeSwitchValueMode = async (event, newValue, setStateObj) => {
  await setStateObj({
    selectedMode: newValue
  });
};
export const getCommonBottomNavigationData = (classes) => {
  const data = ['Sombre', 'Clair'];
  const newData = [];
  _.map(data, e => {
    newData.push({
      label: e,
      icon:
        e === data[0] ? (
          <Brightness2OutlinedIcon className={classes.iconStyle} />
        ) : (
          <FlareOutlinedIcon className={classes.iconStyle} />
        )
    });
  });
  return newData;
};
